import { theme } from '@global-engineering-shared/gweb-material-theme-next';
import { ButtonClassKey } from '@global-engineering-shared/gweb-material-types';
import { StyleRules } from '@material-ui/core/styles';

export const ButtonOverrides: Partial<StyleRules<ButtonClassKey, Record<string, unknown>>> = {
  ...theme.overrides?.MuiButton,
  containedPrimary: {
    '&.Mui-disabled': {
      backgroundColor: theme.palette.gray[100],
      color: theme.palette.gray[400],
    },
  },
};
